import React, { useState, useEffect } from 'react';

function ModalListePatients({ API_URL, token, onFermer, onVoirHistorique }) {
    const [patients, setPatients]   = useState([]);
    const [recherche, setRecherche] = useState('');

    useEffect(() => {
        chargerPatients();
    }, []);

    async function chargerPatients(rech = '') {
        const url = rech
            ? `${API_URL}/patients?recherche=${encodeURIComponent(rech)}`
            : `${API_URL}/patients`;
        const res = await fetch(url, { headers: { Authorization: `Bearer ${token}`, "ngrok-skip-browser-warning": "true" } });
        const data = await res.json();

        if (rech) {
            const q = rech.toLowerCase();
            const filtres = data.filter(p =>
                (p.nom       || '').toLowerCase().includes(q) ||
                (p.prenom    || '').toLowerCase().includes(q) ||
                (p.telephone || '').includes(q)
            );
            setPatients(filtres);
        } else {
            setPatients(data);
        }
    }

    const thStyle = {
        textAlign: 'left', padding: '10px 12px',
        color: 'var(--text-muted)', fontWeight: 500
    };

    return (
        <div
            onClick = {e => e.target === e.currentTarget && onFermer()}
            style={{
                display: 'flex', position: 'fixed', inset: 0,
                background: 'rgba(0,0,0,0.6)', zIndex: 100,
                alignItems: 'center', justifyContent: 'center'
            }}
        >
            <div style={{
                background: 'var(--bg-light)', border: '1px solid var(--border)',
                padding: '32px', borderRadius: '12px',
                width: '800px', maxWidth: '95vw', maxHeight: '80vh',
                display: 'flex', flexDirection: 'column'
            }}>
                {/* Header */}
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '24px' }}>
                    <h3 style={{ fontSize: '16px', fontWeight: 500, color: 'var(--white)' }}>
                        👥 Liste des patients
                    </h3>
                    <button
                        onClick = {onFermer}
                        style={{
                            background: 'none', border: 'none',
                            color: 'var(--text-muted)', fontSize: '18px',
                            cursor: 'pointer', padding: '4px 8px'
                        }}
                    >✕</button>
                </div>

                {/* Recherche */}
                <input
                    type        = "text"
                    value       = {recherche}
                    placeholder = "Rechercher un patient..."
                    onChange    = {e => {
                        setRecherche(e.target.value);
                        chargerPatients(e.target.value);
                    }}
                    style={{
                        width: '100%', padding: '9px 14px',
                        background: 'var(--bg)', border: '1px solid var(--border)',
                        borderRadius: '8px', color: 'var(--text)',
                        fontSize: '13px', outline: 'none', marginBottom: '16px'
                    }}
                />

                {/* Tableau */}
                <div style={{ overflowY: 'auto', flex: 1 }}>
                    {patients.length === 0 ? (
                        <div style={{ textAlign: 'center', padding: '32px', color: 'var(--text-muted)', fontSize: '13px' }}>
                            Aucun patient trouvé
                        </div>
                    ) : (
                        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
                            <thead>
                                <tr style={{ borderBottom: '1px solid var(--border)' }}>
                                    <th style={thStyle}>Prénom</th>
                                    <th style={thStyle}>Nom</th>
                                    <th style={thStyle}>Téléphone</th>
                                    <th style={thStyle}>Sexe</th>
                                    <th style={thStyle}>Âge</th>
                                    <th style={{ ...thStyle, textAlign: 'center' }}>Historique</th>
                                </tr>
                            </thead>
                            <tbody>
                                {patients.map(patient => (
                                    <tr
                                        key   = {patient.id}
                                        style={{ borderBottom: '1px solid var(--border)' }}
                                    >
                                        <td style={{ padding: '12px', color: 'var(--text)' }}>{patient.prenom || '—'}</td>
                                        <td style={{ padding: '12px', color: 'var(--text)' }}>{patient.nom    || '—'}</td>
                                        <td style={{ padding: '12px', color: 'var(--text-muted)' }}>{patient.telephone || '—'}</td>
                                        <td style={{ padding: '12px', color: 'var(--text-muted)' }}>
                                            {patient.sexe === 'M' ? '♂ Homme' : patient.sexe === 'F' ? '♀ Femme' : '—'}
                                        </td>
                                        <td style={{ padding: '12px', color: 'var(--text-muted)' }}>
                                            {patient.age ? `${patient.age} ans` : '—'}
                                        </td>
                                        <td style={{ padding: '12px', textAlign: 'center' }}>
                                            <button
                                                onClick = {() => onVoirHistorique(patient)}
                                                style={{
                                                    background: 'transparent',
                                                    border: '1px solid var(--border)',
                                                    color: 'var(--text-muted)',
                                                    padding: '5px 12px', borderRadius: '6px',
                                                    cursor: 'pointer', fontSize: '12px'
                                                }}
                                            >
                                                📋 Voir
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>
            </div>
        </div>
    );
}

export default ModalListePatients;